import { request, axiosInstance } from '../instance';
import { IFilterParams } from 'interfaces/IFilterParams';

export const PostLogImportRecordsAPI = {
  getList: async (params: IFilterParams) => {
    try {
      const response = await request({
        url: 'v1/post_log_import_records',
        method: 'GET',
        params,
      });
      return response.data;
    } catch (error: any) {
      return error?.response;
    }
  },

  create: async (params: { file_name: string }, file: File) => {
    try {
      const response = await request({
        url: 'v1/post_log_import_records',
        method: 'POST',
        headers: { 'Content-Type': 'text/csv' },
        data: file,
        params,
      });
      return response.data;
    } catch (error: any) {
      return error?.response;
    }
  },

  confirm: async (id: number) => {
    try {
      const response = await request({
        url: `v1/post_log_import_records/${id}/confirm`,
        method: 'POST',
      });
      return response.data;
    } catch (error: any) {
      return error?.response;
    }
  },

  cancel: async (id: number) => {
    try {
      const response = await request({
        url: `v1/post_log_import_records/${id}`,
        method: 'DELETE',
      });
      return response.data;
    } catch (error: any) {
      return error?.response;
    }
  },

  downloadExceptions: async (id: number) => {
    try {
      const response = await axiosInstance.get(
        `v1/post_log_import_records/${id}/exceptions`,
        { responseType: 'blob' },
      );
      return response;
    } catch (error: any) {
      return error?.response;
    }
  },
};

export default PostLogImportRecordsAPI;
